<template>
  <div class="mains" @mouseenter="submit11()">
    <div class="campus">
      教材管理
      <span>></span>
      <router-link to="selfbook">自制教材区</router-link>
      <span>></span>
      {{ bj_zz ? bj_zz2 : bj_zz1 }}
    </div>
    <div class="xiaoqu">
      <div class="grid-content trialscope0">
        <el-dialog title="试用范围" :visible.sync="addStudents">
          <div class="form_1 form_1_1">
            <el-form
              ref="Trialscope"
              :model="Trialscopes"
              :rules="FormRules"
              label-width="5.20833vw"
            >
              <el-form-item label="试用范围" class="fanwei0">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-input v-model="form.name" disabled></el-input>
              </el-form-item>
              <el-form-item label>
                <div class="fanwei1 scrollbarStyle">
                  <div
                    v-for="(item, index) in shiyongzhangjie"
                    :key="index"
                    :class="item.probation === 1 ? 'fanwei1_0' : ''"
                    @click="fanweis0(item)"
                  >
                    <span v-if="item.level === 0" class="fanwei1_1">
                      {{ item.title }}
                    </span>
                    <span v-if="item.level === 1">{{ item.title }}</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label>
                <div class="fanwei2">
                  （注：在选择可试用范围时，选择的为章节时，选中为它之前的所有内容；为内容时，所选中的为它和它之前的所有内容）
                </div>
              </el-form-item>
              <el-form-item class="queding">
                <el-button type="primary" @click="qd_shiyong">确定</el-button>
                <el-button @click="quxiao">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
        <el-card :span="24">
          <div class="xiaoqu_1">{{ bj_zz ? bj_zz2 : bj_zz1 }}</div>
          <div class="shenzhong">
            <i class="img_1">
              <img
                src="@/assets/img/education-manage/campus/shenzhong.png"
                alt
              />
            </i>
            自制课本分为"保存课本"与"发布课本"两种选择，保存课本是将自制的课本保存且存档，发布课本是将自制的课本发布至小程序端。
          </div>
          <div class="form_1 right kbfm">
            <el-form
              ref="forms"
              :model="form"
              :rules="FormRules"
              label-width="5.20833vw"
            >
              <el-form-item label="课本名称" prop="name">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-input
                  v-model="form.name"
                  placeholder="请输入课本名称 ( 可填写中英文 )"
                  :disabled="this.show"
                  @blur="blur"
                  @keyup.enter.native="$event.target.blur"
                ></el-input>
                <div class="shangchuan_yinyue">
                  <el-button class="daoru_btn" @click="updateChapter1">
                    重命名
                  </el-button>
                  <el-button
                    v-if="shiyongfanwei"
                    class="daoru_btn daoru_btn2"
                    @click="updateChapter2"
                  >
                    <img src="@/assets/img/textbook-manage/selfbook/suo.png" />
                    <span style="position: relative; top: -1px"> 试用范围</span>
                  </el-button>
                </div>
              </el-form-item>

              <el-form-item label="课本简称" prop="name">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-input
                  v-model="form.shortname"
                  placeholder="请输入课本简称 ( 可填写中英文 )"
                ></el-input>
              </el-form-item>
              <el-form-item label="排序号" prop="seqnum">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-input
                  style="width: 10%"
                  type="number"
                  v-model="form.seqnum"
                  placeholder="请输入排序号"
                ></el-input>
              </el-form-item>

              <el-form-item
                class="shangchuan_lbt"
                label="课本封面"
                prop="picurl"
              >
                <!-- <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i> -->
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :http-request="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="tempImg" :src="tempImg" class="avatar1" />
                  <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                </el-upload>
                <el-upload
                  action="#"
                  :show-file-list="false"
                  :http-request="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  class="lbt_item"
                >
                  <el-button size="small" type="primary" class=""
                    >上传封面</el-button
                  >
                </el-upload>
                <span class="genghuan_gnk lbt_span1"
                  >( 您可上传至素材中心并进行分组，可在素材中心进行导入；
                  建议：JPG或PNG图片， 推荐：180*230px )</span
                >
              </el-form-item>

              <el-form-item label="级别" prop="level">
                <el-input
                  v-model="form.level"
                  placeholder="请输入课本所属使用级别"
                ></el-input>
              </el-form-item>

              <el-form-item label="所属分类" prop="name">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-select v-model="groupid" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in xuanzejuese"
                    @click.native="ssfenlei = item.name"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="是否试用" prop="level" class="shidoushiyong">
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-switch
                  v-model="shi0yong"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
                （此处功能用于是否有试用章节，若开关为关闭状态，则此教材为公共教材，用户使用时不需要激活；若开关为打开状态，则此教材在使用时有试用部分与付费部分，付费功能需去激活该教材）
              </el-form-item>
              <!--版权声明-->
              <el-form-item label="版权声明" prop="level" class="shidoushiyong">
                <el-button
                  type="primary"
                  @click="dialogVisible1 = true"
                  v-show="hide"
                  >新建</el-button
                >
                <el-button
                  type="primary"
                  @click="
                    submit2(content);
                    centerDialogVisible = true;
                  "
                  class="preview"
                  >预览</el-button
                >
                <el-button
                  type="primary"
                  @click="
                    submit2();
                    dialogVisible3 = true;
                  "
                  >修改</el-button
                >
              </el-form-item>
              <!-- 新建版权声明 -->
              <el-dialog
                title="新建"
                :visible.sync="dialogVisible1"
                width="30%"
              >
                <quill-editor
                  ref="text"
                  style="margin-bottom: 10px"
                  v-model="content1"
                  class="myQuillEditor"
                  :options="editorOption"
                  v-show="richText"
                />
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogVisible1 = false"
                    >取消</el-button
                  >
                  <el-button type="primary" @click="submit1">确 定</el-button>
                </span>
              </el-dialog>
              <!-- 预览 -->
              <el-dialog
                title="预览"
                :visible.sync="centerDialogVisible"
                width="30%"
              >
                <p v-html="content" class="contentp"></p>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="centerDialogVisible = false"
                    >确 定</el-button
                  >
                </span>
              </el-dialog>
              <!-- 修改 -->
              <el-dialog
                title="替换"
                :visible.sync="dialogVisible3"
                width="30%"
                :before-close="handleClose"
              >
                <quill-editor
                  ref="text"
                  style="margin-bottom: 10px"
                  v-model="content"
                  class="myQuillEditor"
                  :options="editorOption"
                  v-show="richText"
                />
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="dialogVisible3 = false"
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    @click="
                      submit3();
                      dialogVisible3 = false;
                    "
                    >确 定</el-button
                  >
                </span>
              </el-dialog>
              <!-- 板块框架 -->
              <el-form-item
                label="板块框架"
                class="shangchuan_bg1"
                prop="orgcode"
              >
                <i>
                  <img
                    src="@/assets/img/education-manage/campus/bitian.png"
                    alt
                  />
                </i>
                <el-input
                  v-model="orgcode"
                  placeholder="请输入您新建的单元名称"
                  @keyup.enter.native="addBookUnit"
                ></el-input>
                <div class="shangchuan_yinyue">
                  <el-button class="daoru_btn" @click="addBookUnit">
                    新建 Unit
                  </el-button>
                </div>
              </el-form-item>

              <el-form-item label prop="orgcode" class="shangchuan_bg">
                <div class="grid-content">
                  <div class="zsbg weijuchang">
                    <el-table :data="tableData" border style="width: 62.8125vw">
                      <el-table-column
                        prop="title"
                        label="课本及单元名称"
                        max-width="360"
                      >
                        <template slot-scope="scope1">
                          <!-- {{ scope1.row }} -->
                          <input
                            type="text"
                            class="yp_name"
                            :class="
                              scope1.row.selected ? 'yp_name2' : 'yp_name1'
                            "
                            v-model="scope1.row.title"
                            :disabled="scope1.row.selected"
                            :id="scope1.row.selected ? '' : 'inputId'"
                            @blur="blur1(scope1.$index, tableData)"
                            @keyup.13="blur1(scope1.$index, tableData)"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="章节排序">
                        <template slot-scope="scopes">
                          <el-input
                            v-model="scopes.row.seqnum"
                            class="yp_paixu"
                            @blur="blur1(scopes.$index, tableData)"
                            @keyup.enter.native="
                              $event.target.blur(scopes.$index, tableData)
                            "
                          ></el-input>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作">
                        <template slot-scope="stData">
                          <el-button
                            type="text"
                            @click="chong(stData.$index, tableData)"
                          >
                            重命名
                          </el-button>
                          <el-button
                            type="text"
                            @click="bianji_tiaozhuan(stData.row.id)"
                          >
                            编辑Unit
                          </el-button>
                          <el-button
                            type="text"
                            @click="deleteBookUnit(stData.row.id)"
                          >
                            删除Unit
                          </el-button>
                          <!-- <el-button type="text" @click="zhizuo_py(stData.row)">
                          添加课件
                        </el-button> -->
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="备注" prop="description" class="beizhu">
                <el-input type="textarea" v-model="form.description"></el-input>
              </el-form-item>

              <el-form-item class="tijiao">
                <el-button type="primary" @click="addBook"> 保存 </el-button>
                <router-link to="selfbook">
                  <el-button>取消</el-button>
                </router-link>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "addBook",
  components: { quillEditor },
  data() {
    return {
      form: {
        name: "",
        description: "",
        seqnum: "",
        level: "",
        shortname: "",
      },
      FormRules: {},
      orgcode: "",
      show: true,
      disabled1: true,
      tempImg: "",
      banji_id: {},
      tableData: [],
      gh_yp: "",
      addbookId: "",
      bj_zz: false,
      bj_zz1: "制作课本",
      bj_zz2: "编辑课本",
      shi0yong: false,
      needactive: "",
      shiyongfanwei: false,
      addStudents: false,
      Trialscopes: {},
      shiyongzhangjie: [],
      ssfenlei: "请选择...",
      xuanzejuese: [],
      groupid: "",
      content: "",
      content1: "",
      editorOption: {},
      centerDialogVisible: false,
      dialogVisible1: false,
      dialogVisible3: false,
      hite: false,
      richText: true,
      hide: false,
      bookid: "",
      components: { quillEditor },
    };
  },
  created() {
    if (!this.$store.state.addbookId) {
      this.$router.push({ name: "selfbook" });
      return this.$message.error("您当前的课本数据获取失败！");
    }

    this.addbookId = this.$store.state.addbookId;
    // console.log(this.addbookId)
    if (this.addbookId === true) {
      this.bj_zz = false;
    } else {
      this.bj_zz = true;
    }
    if (this.bj_zz === true) {
      this.show = true;
    } else {
      this.show = false;
    }
    this.getGroupList();
  },
  destroyed() {
    localStorage.removeItem("addbookId");
  },
  watch: {
    shi0yong(n, o) {
      // console.log(n, o)
      if (n === true) {
        this.needactive = 1;
        this.shiyongfanwei = true;
      } else {
        this.needactive = 0;
        this.shiyongfanwei = false;
      }
    },
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //判断新建内容
    submit11() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let bookid = this.addbookId;
      let pro = this.$http({
        url: "/edu/bookcopyright/viewCopyright",
        method: "GET",
        params: {
          bookid: bookid,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      pro.then((result) => {
        console.log(result);
        if (result.data.code === 150001) {
          this.hide = true;
        } else {
          this.hide = false;
        }
      });
    },
    //新建
    submit1() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let bookid = this.addbookId;
      let pro = this.$http({
        url: "/edu/bookcopyright/addCopyright",
        method: "POST",
        data: {
          bookid: bookid,
          copyright: this.content1,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
            this.bookid = result.data.data.bookid;
            this.$message.success("修改成功");
            this.hide = false;
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("添加失败：" + err);
        });
    },
    //预览
    submit2() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let bookid = this.addbookId;
      let pro = this.$http({
        url: "/edu/bookcopyright/viewCopyright",
        method: "GET",
        params: {
          bookid: bookid,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result);
          if (result.data.code === 0) {
            // this.bookid = result.data.data.bookid;
            this.content = result.data.data.copyright;
            console.log(bookid);
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("查看失败：" + err);
        });
    },
    //替换
    submit3() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let bookid = this.addbookId;
      let pro = this.$http({
        url: "/edu/bookcopyright/updateCopyright",
        method: "POST",
        data: {
          bookid: bookid,
          copyright: this.content,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          console.log(result);
          if (result.data.code === 0) {
            this.submit2();
            this.content = result.data.copyright;
            this.$message.success("修改成功");
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============');
          this.$message.error("查看失败：" + err);
        });
    },

    getGroupList() {
      let orgid = window.sessionStorage.getItem("orgid");
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/edu/book/getGroupList/" + orgid,
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result, 'getGroupList')
          this.xuanzejuese = result.data.data;
          this.getBookById();
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("获取所属分类列表失败：" + err);
        });
    },
    // guanli(item) {
    //   console.log(item);
    //   this.ssfenlei = item.name;
    //   this.groupid = item.id;
    // },

    bianji_tiaozhuan(UnitId) {
      this.$store.commit("UnitId", UnitId);
      this.$store.commit("addbookIds", this.addbookId);
      this.$router.push({ name: "addBookChapter" });
    },

    // 上传图片
    handleAvatarSuccess(data) {
      // console.log(data.file)
      let orgid = window.sessionStorage.getItem("orgid");
      let formData = new FormData();
      formData.append("file", data.file);
      formData.append("orgid", orgid);
      console.log(formData);
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/mini/miniInfo/uploadimage",
        method: "POST",
        data: formData,
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let url = result.data.data;
            this.tempImg = url;
          } else {
            this.$message.error(result.data.message);
          }
          // console.log(this.tempImg)
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("系统错误：" + err);
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        return false;
      }
      return isJPG | isPNG && isLt2M;
    },

    // 重命名
    updateChapter1() {
      this.show = false;
    },
    blur() {
      this.show = true;
    },

    qd_shiyong() {
      // console.log(this.shiyongzhangjie)
      let arr = [];
      for (var i = 0; i < this.shiyongzhangjie.length; i++) {
        if (this.shiyongzhangjie[i].probation === 1) {
          // console.log(i)
          arr.push(this.shiyongzhangjie[i]);
        }
      }
      // console.log(arr)
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/edu/book/updateBookProbation",
        data: arr,
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.addStudents = false;
          return this.$message.success(result.data.message);
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error("确定试用范围失败：" + err);
        });
    },
    fanweis0(item) {
      // console.log(item)
      for (var a = 0; a < this.shiyongzhangjie.length; a++) {
        this.shiyongzhangjie[a].probation = 0;
      }
      if (item.level === 1) {
        for (var l = 0; l < this.shiyongzhangjie.length; l++) {
          if (
            this.shiyongzhangjie[l].level === 1 &&
            item.id === this.shiyongzhangjie[l].id
          ) {
            for (var b = 0; b < l + 1; b++) {
              // console.log(this.shiyongzhangjie[b])
              this.shiyongzhangjie[b].probation = 1;
            }
          }
        }
      } else {
        for (var i = 0; i < this.shiyongzhangjie.length; i++) {
          if (
            this.shiyongzhangjie[i].level === 0 &&
            item.id === this.shiyongzhangjie[i].id
          ) {
            for (var j = 0; j < i; j++) {
              // console.log(this.shiyongzhangjie[j])
              this.shiyongzhangjie[j].probation = 1;
            }
          }
        }
      }
    },
    // 查询试用范围
    updateChapter2() {
      this.addStudents = true;
      let bookid = this.addbookId;
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/edu/book/getCatalogueByBook/" + bookid,
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          console.log(result.data.data);
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.shiyongzhangjie = result.data.data;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error("查询试用范围失败：" + err);
        });
    },
    quxiao() {
      this.addStudents = false;
    },

    chong(index, rows) {
      // console.log(index)
      // console.log(rows[index])
      rows[index].selected = false;
      document.getElementById("inputId").focus();
      // this.$refs.id.focus()
    },

    blur1(index, rows) {
      // console.log(rows[index])
      rows[index].selected = true;

      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/edu/bookunit/updateBookUnit",
        method: "POST",
        data: {
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum,
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.getBookUnitList();
            return this.$message.success("Unit修改成功！");
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error("Unit修改失败：" + err);
        });
    },

    // 查询Unit
    getBookUnitList() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      let pro = this.$http({
        url: "/edu/bookunit/getBookUnitList/" + this.addbookId,
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.tableData = result.data.data;
            for (var i = 0; i < this.tableData.length; i++) {
              this.tableData[i].selected = true;
            }
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("查询Unit失败：" + err);
        });
    },

    // 新增Unit
    addBookUnit() {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      if (this.bj_zz === false) {
        return this.$message.error("请先保存新建的课本！");
      }
      if (this.orgcode === "") {
        return this.$message.error("请输入Unit的名称！");
      }
      let pro = this.$http({
        url: "/edu/bookunit/addBookUnit",
        method: "POST",
        data: {
          bookid: this.addbookId,
          title: this.orgcode,
          seqnum: "",
        },
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code === 0) {
            this.getBookUnitList();
            this.orgcode = "";
          } else {
            return this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error("新增Unit失败：" + err);
        });
    },

    // 删除Unit
    deleteBookUnit(id) {
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      this.$confirm("确认要删除吗?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: "/edu/bookunit/deleteBookUnit/" + id,
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code === 0) {
              this.getBookUnitList();
              return this.$message.success("删除Unit成功!");
            } else {
              return this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            // console.log(err)
            return this.$message.error("删除Unit失败：" + err);
          });
      });
    },

    // 查询课本
    getBookById() {
      // let orgid = window.sessionStorage.getItem('orgid')
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");
      if (this.bj_zz === true) {
        let pro = this.$http({
          url: "/edu/book/getBookById/" + this.addbookId,
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        pro
          .then((result) => {
            console.log(result, "getBookById");
            if (result.data.code === 0) {
              this.form = result.data.data;
              this.tempImg = result.data.data.picurl;
              if (this.form.needactive === 1) {
                this.shi0yong = true;
              } else {
                this.shi0yong = false;
              }
              this.getBookUnitList();
              this.groupid = result.data.data.groupid;
              for (var i = 0; i < this.xuanzejuese.length; i++) {
                if (this.groupid === this.xuanzejuese[i].id) {
                  // console.log(i)
                  this.ssfenlei = this.xuanzejuese[i].name;
                }
              }
            } else {
              return this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error("查询课本失败：" + err);
          });
      }
    },

    // 新增课本 保存
    addBook() {
      let orgid = window.sessionStorage.getItem("orgid");
      let token = window.sessionStorage.getItem("userinfo").replace(/"/g, "");

      if (this.form.name === "") {
        return this.$message.error("请输入课本的名称！");
      }
      if (this.form.shortname === "") {
        return this.$message.error("请输入课本的简称！");
      }
      if (this.form.seqnum === "") {
        return this.$message.error("请输入课本的排序号！");
      }
      if (this.groupid === "") {
        return this.$message.error("请选择教材所属分类！");
      }

      if (this.bj_zz === false) {
        // console.log(this.form)
        let pro = this.$http({
          url: "/edu/book/addBook",
          method: "POST",
          data: {
            name: this.form.name,
            shortname: this.form.shortname,
            seqnum: this.form.seqnum,
            orgid: orgid,
            picurl: this.tempImg,
            level: this.form.level,
            description: this.form.description,
            type: 1,
            groupid: this.groupid,
          },
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            if (result.data.code === 0) {
              this.bj_zz = true;
              this.show = true;
              window.localStorage.setItem("addbookId", result.data.data.id);
              this.$router.push({ name: "selfbook" });
              return this.$message.success("新增课本成功!");
            } else {
              return this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error("新增课本失败：" + err);
          });
      } else if (this.bj_zz === true) {
        let pro = this.$http({
          url: "/edu/book/updateBook",
          method: "POST",
          data: {
            id: this.addbookId,
            name: this.form.name,
            shortname: this.form.shortname,
            seqnum: this.form.seqnum,
            orgid: orgid,
            picurl: this.tempImg,
            level: this.form.level,
            needactive: this.needactive,
            description: this.form.description,
            groupid: this.groupid,
          },
          headers: {
            Authorization: "Bearer " + token,
          },
        });
        pro
          .then((result) => {
            // console.log(result)
            console.log(this.groupid);
            if (result.data.code === 0) {
              this.$message.success("修改课本成功!");
              this.$router.go(-1); //返回上一层
              return;
            } else {
              return this.$message.error(result.data.message);
            }
          })
          .catch((err) => {
            // console.log('error===============')
            this.$message.error("修改课本失败：" + err);
          });
      }
    },
  },
};
</script>

<style lang="less">
.mains .xiaoqu {
}

.shidoushiyong {
  color: #ccc;
  font-size: 12px;
  .el-switch {
    padding-left: 20px;
  }
}
.el-form-item__content {
  .shangchuan_yinyue .daoru_btn2 {
    left: 722px !important;
    width: 98px !important;
    img {
      width: 12px;
      height: 14px;
      position: relative;
      top: 1px;
      margin-right: 2px;
    }
  }
}

.mains .el-card .form_1 .el-form-item .suoshu .el-button--primary:hover {
  border: 1px solid #0094ce;
}

.mains .el-card .form_1 .el-form-item .suoshu .el-button--primary {
  font-size: 14px;
  height: 36px;
  width: 175px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: none;
  border-radius: 4px;
  color: #606266;
  position: relative;
  top: -4px;
  span {
    position: absolute;
    top: 10px;
    left: 0;
    padding-left: 20px;
    i {
      position: absolute;
      // right: -83px;
      left: 138px;
    }
  }
}
.kbfm {
  .shangchuan_lbt {
    .el-form-item__label {
      top: -10px;
    }
    .avatar1 {
      width: 125px !important;
      height: 159px !important;
    }

    .genghuan_gnk {
      left: 155px !important;
    }
    .lbt_item {
      .lbt_btn {
        width: 85px !important;
        padding: 7px 0 0 17px;
      }
    }
    .lbt_span1 {
      margin-left: 97px !important;
    }
  }
  .avatar-uploader-icon1 {
    width: 125px !important;
    height: 159px !important;
    line-height: 159px !important;
  }
  .shangchuan_bg1 {
    margin-bottom: 25px !important;
  }

  .beizhu {
    .el-textarea__inner {
      height: 120px !important;
    }
  }
}
.suoshufenleidropdowns {
  margin: 0;
  padding: 0;
  border: 0;
  position: relative;
  // top: 208px !important;
  left: 604px !important;
  z-index: 0 !important;
  .el-dropdown-menu__item {
    font-size: 0.73vw;
    color: #666;
    line-height: 1.5625vw;
    margin: 0 auto;
    width: 8.4vw;
    padding: 0 0 0 15px !important;
    height: 34px;
  }
  li:visited {
    color: #00a6e6;
  }
  .el-dropdown-menu__item:first-child {
    border-radius: 5px 5px 0 0;
  }
  .el-dropdown-menu__item:nth-last-child(2) {
    border-radius: 0 0 5px 5px;
  }
  .el-dropdown-menu__item:hover {
    background: #00a6e6;
    color: #fff;
  }
  .popper__arrow {
    border: 0px solid #ccc !important;
  }
}
</style>

